import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Query orchid pro
 */
export default async function queryOrchidPro(
  onBehalfOf?: string,
): Promise<OrchidPro> {
  const res = await fetchOrchidAPI(
    `/api/users/v1/orchid_pro/${
      onBehalfOf ? `?on_behalf_of=${onBehalfOf}` : ""
    }`,
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  return res.json();
}
